module.exports = __webpack_public_path__ + "media/goofy.5db6cc78.mp3";